import axios from 'axios'

/*
 * Single Report operations
 */

async function getCaseReportApi(id) {
  try {
    const response = await axios.get(`/api/caseReport/${id}`)
    return response.data
  } catch (error) {
    console.error('Error getting case report.', error);
    throw error
  }
}

async function addCommentApi(caseReportId, comment) {
  try {
    const response = await axios.post("/api/caseReport/" + caseReportId + "/comment", { comment: comment })
    return response.data
  } catch (error) {
    console.error('Error saving report comment.', error);
    throw error
  }
}

async function setStatusApi(caseReportId, status) {
  try {
    const response = await axios.post(`/api/caseReport/${caseReportId}/status/${status}`)
    return response.data
  } catch (error) {
    console.error('Error setting report status.', error);
    throw error
  }
}

async function setAssigneeApi(caseReportId, assignee) {
  try {
    const response = await axios.post("/api/caseReport/" + caseReportId + "/assign", { assignee: assignee })
    return response.data
  } catch (error) {
    console.error('Error setting report assignee.', error);
    throw error
  }
}

/*
 * Bulk Report operations
 */

async function getCaseReportsApi(paginationRequest) {
  try {
    const response = await axios.post("/api/caseReports", paginationRequest)
    return response.data
  } catch (error) {
    console.error('Error getting case reports.', error);
    throw error
  }
}

async function setAssigneeBulkApi(caseReportIds, assignee) {
  try {
    const response = await axios.post("/api/caseReports/assign",
      {
        caseReportIds: caseReportIds,
        assignee: assignee
      })
    return response.data
  } catch (error) {
    console.error('Error setting bulk report assignee.', error);
    throw error
  }
}

async function downloadCaseReportCsvApi(params) {
  const url = '/api/export/csv/casereports';

  try {
    await axios
    .post(url, params, {
      responseType: 'blob'
    })
    .then((response) => {
      // Extract filename from Content-Disposition header (fallback to default)
      let filename = 'veriscan-case-report-export.csv';
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/i);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create blob and trigger download
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    })
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
}

export { getCaseReportApi, addCommentApi, setStatusApi, setAssigneeApi, getCaseReportsApi, setAssigneeBulkApi, downloadCaseReportCsvApi }